// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"73dd4ed8","205":"35e53c5a","498":"74a13ffd","501":"d33fe648","692":"c38165c8"}[chunkId] + ".chunk.css";
};